import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/touristBookingFields', request)
}

export {get}
